module.exports = __webpack_public_path__ + "static/media/villas-icon.e461fee0.PNG";